import { DeviceStatus } from '../types/device';
import { Registration } from '../types/registrationTypes';

const getRegistrationStatus = (registration: Registration) => {
  const stepsCompleted = {
    customer: customerIsComplete(registration.customer),
    location: locationIsComplete(registration.location),
    heatingSetup: heatingSetupIsComplete(registration.heatingSetup),
    devices: devicesIsComplete(registration.devices)
  };
  const totalSteps = Object.keys(stepsCompleted).length;
  const numStepsCompleted = Object.values(stepsCompleted).filter(Boolean).length;
  return {
    progress: `${numStepsCompleted}/${totalSteps}`,
    canBeCompleted: numStepsCompleted === totalSteps,
    stepCompleted: stepsCompleted,
    customerIsComplete: stepsCompleted.customer,
    locationIsComplete: stepsCompleted.location,
    heatingSetupIsComplete: stepsCompleted.heatingSetup,
    devicesIsComplete: stepsCompleted.devices
  };
};

const customerIsComplete = (customer: Registration['customer']) => {
  return (
    !!customer?.firstName &&
    !!customer?.lastName &&
    !!customer?.address &&
    !!customer?.zipCode &&
    !!customer?.city &&
    !!customer?.phone &&
    !!customer?.type &&
    !!customer?.insuranceType &&
    !!customer?.country
  );
};

const locationIsComplete = (location: Registration['location']) => {
  return !!location?.installationAddress && !!location?.zipCode && !!location?.city && !!location?.installationDate && !!location?.country;
};

const heatingSetupIsComplete = (heatingSetup: Registration['heatingSetup']) => {
  return (
    !!(heatingSetup?.heatSource ? heatingSetup.heatSource.length > 0 : false) &&
    !!(heatingSetup?.heatSystem ? heatingSetup.heatSystem.length > 0 : false) &&
    !!heatingSetup?.coolant
  );
};

const devicesIsComplete = (devices: Registration['devices']) => {
  if (!devices || !Array.isArray(devices.items) || devices.items.length === 0) {
    return false;
  }
  return devices.items.every((device) => device.status === DeviceStatus.pending);
};

export { customerIsComplete, getRegistrationStatus, locationIsComplete };

